// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_b0d89c6","translation":"_09639ce","regulatoryIcon":"_efe5f3d"};